import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "career" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MdContent = _resolveComponent("MdContent")
  const _component_Jobs = _resolveComponent("Jobs")
  const _component_Education = _resolveComponent("Education")
  const _component_AiTabs = _resolveComponent("AiTabs")
  const _component_CollapseMenu = _resolveComponent("CollapseMenu")

  return (_openBlock(), _createBlock(_component_CollapseMenu, {
    loading: $options.loading,
    class: "collapse-menu",
    title: $options.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_AiTabs, {
          modelValue: $data.active_tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active_tab) = $event)),
          tabs: $options.tabs
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          ($options.summary)
            ? {
                name: "summary",
                fn: _withCtx(() => [
                  _createVNode(_component_MdContent, {
                    class: "summary",
                    markdown: $options.summary
                  }, null, 8 /* PROPS */, ["markdown"])
                ]),
                key: "0"
              }
            : undefined,
          ($options.jobs)
            ? {
                name: "jobs",
                fn: _withCtx(() => [
                  _createVNode(_component_Jobs, { jobs: $options.jobs }, null, 8 /* PROPS */, ["jobs"])
                ]),
                key: "1"
              }
            : undefined,
          ($options.education)
            ? {
                name: "education",
                fn: _withCtx(() => [
                  _createVNode(_component_Education, { education: $options.education }, null, 8 /* PROPS */, ["education"])
                ]),
                key: "2"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "tabs"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["loading", "title"]))
}